<template>
  <div
    class="border rounded-lg border-gray-300 dark:border-gray-700 text-[11px] mr-3 mt-2 whitespace-nowrap inline-flex items-center overflow-hidden shadow-sm"
  >
    <span
      class="bg-gray-100 dark:bg-gray-800 px-2 py-1 font-bold text-gray-600 dark:text-gray-400 border-r border-gray-300 dark:border-gray-700"
      >{{ tagName }}</span
    >
    <span class="bg-white/50 dark:bg-[#0d1a20]/50 px-2 py-1 flex gap-2">
      <span v-for="(value, index) in values" :key="value">
        <a
          :href="links[index] ? links[index] : '#'"
          target="_blank"
          class="text-blue-700 dark:text-blue-400 hover:text-blue-500 font-medium transition-colors"
          >{{ value }}</a
        ><span
          v-if="index < values.length - 1"
          class="text-gray-400 dark:text-gray-600"
          >,
        </span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    tagName: String,
    tagValue: [String, Array, Number],
    arrayKey: String,
    link: [String, Array],
  },
  data() {
    return {};
  },
  computed: {
    values() {
      if (this.tagValue) {
        if (Array.isArray(this.tagValue)) {
          if (this.arrayKey) {
            return this.tagValue.map((item) => item[this.arrayKey]);
          }
          return this.tagValue;
        }
        return [this.tagValue];
      }
      return [];
    },
    links() {
      if (this.link) {
        if (Array.isArray(this.link)) {
          return this.link;
        }
        return [this.link];
      }
      return [];
    },
  },
};
</script>
